var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 310,
    id: "e2ZnbhDF0c31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -40 260 240",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.991013 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 125,
    ry: 125,
    transform: "translate(110.008982 100.019785)",
    fill: "#ba8d5b",
    stroke: "#ba8d5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewing);
export default __webpack_public_path__ + "static/media/viewing.da23364e4cf9f0184592a54ad31616b7.svg";
export { ForwardRef as ReactComponent };